const TYPE = 'USER_LOGIN';

const action = (payload) => (dispatch) => dispatch({ type: TYPE, payload });

export default { action, TYPE };
